import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { getProduct, getSelectedProduct } from '@americanexpress/product-ducks';
import { browserHistory } from '@americanexpress/one-app-router';
import EnrollPage from './EnrollPage';
import { usePrevious } from '../../../hooks/usePrevious';
import isDev from '../../../utilities/is-dev';

export function EnrollRouter(props) {
  const selectedProduct = props?.selectedProduct;
  const [validExperience, setValidExperience] = useState(false);
  const previousSelectedProduct = usePrevious(selectedProduct);
  const languageData = props.languageData;

  useEffect(() => {
    if (previousSelectedProduct !== selectedProduct) {
      if (validExperience) {
        const accountKey = props?.product?.account_key;
        const viewAllURL = `/card-benefits/view-all?account_key=${accountKey}`;

        /* istanbul ignore next */
        if (isDev) {
          // TODO: Trigger a beacon call to track scenario.
          console.log(`Experience is validExperience=true in useEffect, route will redirect to ${viewAllURL}`);
          console.log('Behavior is ported from legacy experience to maintain business as usual, may need refactoring');
        }

        browserHistory.push(viewAllURL);
      } else {
        setValidExperience(true);
      }
    }
  }, [selectedProduct, previousSelectedProduct]);

  return (
    <>
      <EnrollPage
        {...props}
        cardname={props.cardname}
        benefitName={props.benname}
        selectedProduct={props.selectedProduct}
        faasApiUrl={props.faasApiUrl}
        cardData={props.cardData}
        languageData={languageData}
        locale={props?.locale}
        backHeaderData={props?.backHeaderData}
      />
      <div>
        <Helmet
          title={`${props?.cleanBenTitle} with ${props?.cardNameFull}: Enroll | American Express`}
          meta={[
            { name: 'description', content: `Get started with ${props?.cleanBenTitle} for Your ${props?.cardNameFull} & Other American Express Card Benefits.` },
          ]}
        />
      </div>
    </>
  );
}

export function mapStateToProps(state) {
  return {
    login: Boolean(getSelectedProduct(state)),
    product:
      getProduct(state),
  };
}

export default connect(mapStateToProps, null)(EnrollRouter);
